import { css } from "styled-components";

// Theme
export const LoginTheme = {
  name: "Login",
  Wrapper: css`
    background-color: ${(props) => props.theme.bgCard};
  `,
};
